import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=4da45cb9&"
import script from "./BreadCrumbs.vue?vue&type=script&lang=ts&"
export * from "./BreadCrumbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports